
import React from 'react';

import ButtonCommandMscMode from './ButtonCommandMscMode';

const ButtonCommandMscModes = (props) => {

    const MODES = [{
        modeId: 'pano',
        title: 'Pano'
    }, {
        modeId: 'pano_points',
        title: 'Pano+Mračno'
    }, {
        modeId: 'points',
        title: 'Mračno'
    }];

    const handleClick = (modeId) => {
        if (props.onSelectMode) {
            props.onSelectMode(modeId);
        }
    }

    const modes = props.modes || MODES.map(item => item.modeId);

    return MODES.filter(item => {
        return (modes.indexOf(item.modeId) !== -1);
    }).map(item => {
        return <ButtonCommandMscMode
            key={item.modeId}
            modeId={item.modeId}
            title={item.title}
            selected={props.value === item.modeId}
            onClick={handleClick}
        />
    });
}

export default ButtonCommandMscModes;
